// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { fancyA16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-fancy-a': IconFancyA;
    }
}

/**
 * The icon component for the 'fancyA' icon
 */
export class IconFancyA extends IconSvg {
    public constructor() {
        super(fancyA16X16);
    }
}

registerIconSvg('icon-fancy-a', IconFancyA);
export const iconFancyATag = 'nimble-icon-fancy-a';
